module.exports = __webpack_public_path__ + "img/delete_popup.b7377629.svg";